import { Link } from 'react-router-dom';

/**
 * The one "this link does not work" state for the signed-out pages: the SSO
 * callback, password reset and account setup all show it the same way, with
 * the same wording for the way back. They used to differ (a red banner with a
 * full-width button on one, an icon card on the others, three labels for the
 * same link).
 */
export const BACK_TO_SIGN_IN = 'Back to sign in';

export function AuthLinkProblem({
  title,
  message,
  action = { to: '/login', label: BACK_TO_SIGN_IN },
  secondary,
}: {
  title: string;
  message: string;
  action?: { to: string; label: string };
  secondary?: { to: string; label: string };
}) {
  return (
    <div className="py-12 text-center" role="alert">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
        <svg className="h-8 w-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <h2 className="mb-2 text-xl font-semibold text-gray-900 dark:text-white">{title}</h2>
      <p className="mx-auto mb-6 max-w-md text-gray-600 dark:text-gray-400">{message}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link to={action.to} className="btn-primary inline-block">
          {action.label}
        </Link>
        {secondary && (
          <Link to={secondary.to} className="btn-secondary inline-block">
            {secondary.label}
          </Link>
        )}
      </div>
    </div>
  );
}

export default AuthLinkProblem;
